import { ILayoutState } from '../../types/redux/layouts';
import { IRootState } from '../../types/redux/root';

export const layoutStateSelector = (uuid: string) => (root: IRootState): ILayoutState|undefined => root.layouts[uuid];
